import { render } from "./WebOfRelationships.vue?vue&type=template&id=dcc758f8"
import script from "./WebOfRelationships.vue?vue&type=script&lang=js"
export * from "./WebOfRelationships.vue?vue&type=script&lang=js"

import "./WebOfRelationships.vue?vue&type=style&index=0&id=dcc758f8&lang=scss"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/netartmarathon/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__